var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAdmin = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.106,
    height: 21.234,
    viewBox: "0 0 21.106 21.234",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_person_3083850_1_",
    "data-name": "noun_person_3083850 (1)",
    transform: "translate(-21 -17.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19196",
    "data-name": "Path 19196",
    d: "M34.772,29.177a6.063,6.063,0,1,0-6.473,0A10.571,10.571,0,0,0,21,39.221h1.453a9.1,9.1,0,0,1,18.2,0h1.453a10.571,10.571,0,0,0-7.334-10.044Zm-3.237-9.732a4.614,4.614,0,1,1-4.61,4.61,4.614,4.614,0,0,1,4.61-4.61Z",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Admin.fdbfe99c.svg";
export { ForwardRef as ReactComponent };